import angular from 'angular';

module.exports = angular.module('common.filters.valuation-route', [])
.filter('valuationRoute', function() {
  function calculateToolVersion(valuation, defaultVersion) {
    return valuation.tool_version ? valuation.tool_version : defaultVersion;
  }

  return function(valuation, defaultVersion = 4) {
    const toolVersion = calculateToolVersion(valuation, defaultVersion);
    if (toolVersion === 4) {
      return `https://surveyor.apps.opendoor.com/web-valuation/${valuation.id}`;
    }
    return ``;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/valuation-route.js
 **/